import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {AuthService} from '../services/auth.service';
import {Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {AppConfigService} from '../services/app-config.service';
import {ApiUrlConstants} from '../../shared/utils/api-constants';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

  constructor(private authService: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isAuthorizationRequired(req)) {
      return next.handle(req);
    }

    return this.authService.getAuthToken().pipe(switchMap(token => {
      return next.handle(req.clone({setHeaders: {Authorization: 'Bearer ' + token}}));
    }), catchError(error => {
      return this.handleError(req, next, error);
    }));
  }

  private isAuthorizationRequired(req: HttpRequest<any>) {
    const cleanUrl = req.url.split('?')[0];
    return (cleanUrl.startsWith(AppConfigService.apiUrl) ||
      cleanUrl.startsWith(AppConfigService.mobileApiUrl) ||
      cleanUrl.startsWith(AppConfigService.messageStorageManagerApiUrl)
      || cleanUrl.startsWith(AppConfigService.productMangementUrl)
      || cleanUrl.startsWith(AppConfigService.orderApiUrl)
      || cleanUrl.startsWith(AppConfigService.notificationManagerUrl)
      || (this.authService.isLoggedIn() && cleanUrl.startsWith(AppConfigService.emailNotificationManagerUrl))
      || cleanUrl.startsWith(AppConfigService.eoApiUrl)
      || cleanUrl.startsWith(AppConfigService.taxManagerApiUrl)
      || cleanUrl.startsWith(AppConfigService.auditLogsManagerUrl)
      ) && (!ApiUrlConstants.getPermitAllUrl().find(permittedUrl =>
        cleanUrl.endsWith(permittedUrl.url)
        //  && (!permittedUrl.method || permittedUrl.method === req.method)
      ) 
      || (cleanUrl.endsWith(ApiUrlConstants.PRODUCT_DOMAINS) && this.authService.isLoggedIn())
    );
  }

  private handleError(req: HttpRequest<any>, next: HttpHandler, error: HttpErrorResponse): Observable<any> {
    if (error.status === 401 && this.authService.isLoggedIn()) {
      return this.authService.refreshToken().pipe(switchMap(token => {
        return next.handle(req.clone({setHeaders: {Authorization: 'Bearer ' + token}}));
      }), catchError(() => {
        this.authService.logout();
        return of(null);
      }));
    } else if (error.status === 401) {
      this.authService.logout();
      return of(null);
    }

    return throwError(error);
  }
}
